'use client';

import React, { useEffect, useState } from 'react';
import { trpc } from '~/trpc/client';
import { ConfirmationDialog } from './confirmation-dialog';
import { useRouter } from 'next/navigation';

export default function ConfirmOpeningTimes() {
  const router = useRouter();
  const [hasSeenPopup, setHasSeenPopup] = useState<boolean | null>(null);
  const [promptNotRequired, setPromptNotRequired] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    const seen = window.sessionStorage.getItem('CalendarPopupSeen') === 'true';
    setHasSeenPopup(seen);

    const notRequiredStored =
      window.sessionStorage.getItem('CalendarPopupNotRequired') === 'true';
    setPromptNotRequired(notRequiredStored);
  }, []);

  const { data } = trpc.notifications.getShowCalendarPrompt.useQuery(
    undefined,
    {
      enabled: !promptNotRequired && !hasSeenPopup,
    },
  );

  useEffect(() => {
    if (!data) return;

    const stored = sessionStorage.getItem('CalendarPopupNotRequired');
    const alreadySet = stored === 'true';

    if (!data.showPrompt && !alreadySet) {
      sessionStorage.setItem('CalendarPopupNotRequired', 'true');
      setPromptNotRequired(true);
    } else if (data.showPrompt && alreadySet) {
      sessionStorage.removeItem('CalendarPopupNotRequired');
      setPromptNotRequired(false);
    }
  }, [data]);

  const userSeenPopup = () => {
    window.sessionStorage.setItem('CalendarPopupSeen', 'true');
    return;
  };

  if (hasSeenPopup === null || promptNotRequired === null || !data?.showPrompt)
    return null;

  if (hasSeenPopup || promptNotRequired) return null;

  return (
    <ConfirmationDialog
      title="Opening Times"
      description={
        data?.content
          ? data.content
          : `We don’t currently have your up to date opening times for the holiday period, please click OK to update your opening times for each ${
              data?.useShippingTerminology ? 'shipping' : 'delivery'
            } address attached to your account, so we can make sure we deliver to you when you are open.`
      }
      confirmLabel="OK"
      cancelLabel="Close"
      onConfirmClick={() => {
        userSeenPopup();
        void router.push(
          data?.confirmURL
            ? `/redirect/${data.confirmURL}`
            : '/redirect/account/profile?filter=3',
        );

        return;
      }}
      onCancelClick={() => {
        userSeenPopup();
        return;
      }}
      defaultOpen={true}
    />
  );
}
